/*
 * @Author: etong
 * @Date: 2021-01-27 13:51:41
 * @LastEditTime: 2021-05-28 16:38:21
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\store\index.js
 * @Think first, Program later
 */
import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import user from './modules/user'
import vmRouteQuene from './modules/vmRouteQuene'
// 活动结算价提报 => 活动管理界面（创建编辑查看）
import activityDetail from './views/activitySetpriceManagement/activityDetail'
import common from './views/common/'
import financReportFormsTemplate from './views/financReportFormsTemplate'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},
  modules: {
    app,
    permission,
    tagsView,
    user,
    vmRouteQuene,
    activityDetail,
    common,
    financReportFormsTemplate
  },
  getters
})

export default store
